import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UrlQueryService} from '../../common/url-query/url-query.service';
import {MetaDataService} from '../../metaData/meta-data.service';
import {map} from 'rxjs/operators';
import {PeerConnectionFilterService} from '../../filters/peer-connection/peer-connection-filter.service';
import * as _ from 'lodash';


@Injectable({
  providedIn: 'root'
})
export class PeerConnectionApiService {

  constructor(private http: HttpClient,
              private metaDataService: MetaDataService) {}

  readonly pconUrl: string = 'topology/peerCon';

  public getPConsForMap(params: any = {}): Promise<any> {
    return this.http.get(this.pconUrl)
      .pipe(
        map((pCons: any) => {
          pCons.elements = this.filterPeerConnections(pCons.elements, params);
          return pCons;
        })
      ).toPromise();
  }

  public getPConsForMapNew(params: any = {}, allPcons): any {
    const localPcons = _.clone(allPcons);
    localPcons.elements = this.filterPeerConnections(allPcons.elements, params);
    return localPcons;
  }

  public getPCons(params: any = {}): Promise<any> {
    params = UrlQueryService.restructureFilterParams(params);
    const url = UrlQueryService.addQueryParameters(this.pconUrl, params);
    return this.http.get(url).toPromise();
  }

  public getPcon(id: number): Promise<any> {
    return this.http.get(`${this.pconUrl}/${id}`).toPromise();
  }

  public editPCon(peerCon: any, id: number): Promise<any> {
    const url = `${this.pconUrl}/${id}`;
    return this.http.put(url, peerCon).toPromise();
  }

  public addPCon(peerCon: any): Promise<any> {
    return this.http.post(this.pconUrl, peerCon).toPromise();
  }

  public unlockPCon(id: number): Promise<any> {
    const url = `${this.pconUrl}/${id}/lock`;
    return this.http.put(url, {lock: this.metaDataService.PeerConnectionAdminStatus.UNLOCKED.value}).toPromise();
  }

  public lockPCon(id: number): Promise<any> {
    const url = `${this.pconUrl}/${id}/lock`;
    return this.http.put(url, {lock: this.metaDataService.PeerConnectionAdminStatus.LOCKED.value}).toPromise();
  }

  public lockIncomingPCon(id: number): Promise<any> {
    const url = `${this.pconUrl}/${id}/lock`;
    return this.http.put(url, {lock: this.metaDataService.PeerConnectionAdminStatus.LOCKED_INCOMING.value}).toPromise();
  }

  public lockOutgoingPCon(id: number): Promise<any> {
    const url = `${this.pconUrl}/${id}/lock`;
    return this.http.put(url, {lock: this.metaDataService.PeerConnectionAdminStatus.LOCKED_OUTGOING.value}).toPromise();
  }

  public lockPCons(ids): Promise<any> {
    const uri = `${this.pconUrl}/lock`;
    const url = UrlQueryService.addQueryParameters(uri, {filter: {id: {value: ids, operator: '='}}});

    return this.http.put(url, {lock: this.metaDataService.PeerConnectionAdminStatus.LOCKED.value}).toPromise();
  }

  public unlockPCons(ids): Promise<any> {
    const uri = `${this.pconUrl}/lock`;
    const url = UrlQueryService.addQueryParameters(uri, {filter: {id: {value: ids, operator: '='}}});

    return this.http.put(url, {lock: this.metaDataService.PeerConnectionAdminStatus.UNLOCKED.value}).toPromise();
  }

  public lockIncomingPCons(ids): Promise<any> {
    const uri = `${this.pconUrl}/lock`;
    const url = UrlQueryService.addQueryParameters(uri, {filter: {id: {value: ids, operator: '='}}});

    return this.http.put(url, {lock: this.metaDataService.PeerConnectionAdminStatus.LOCKED_INCOMING.value}).toPromise();
  }

  public lockOutgoingPCons(ids): Promise<any> {
    const uri = `${this.pconUrl}/lock`;
    const url = UrlQueryService.addQueryParameters(uri, {filter: {id: {value: ids, operator: '='}}});

    return this.http.put(url, {lock: this.metaDataService.PeerConnectionAdminStatus.LOCKED_OUTGOING.value}).toPromise();
  }

  public deletePCon(id): Promise<any> {
    const url = `${this.pconUrl}/${id}`;
    return this.http.delete(url).toPromise();
  }

  public deletePCons(ids): Promise<any> {
    const url = UrlQueryService.addQueryParameters(this.pconUrl, {filter: {id: {value: ids, operator: '='}}});
    return this.http.delete(url).toPromise();
  }

  public detachPCon(id: number, voIPPeerName: string): Promise<any> {
    const url = `${this.pconUrl}/${id}/detach`;
    return this.http.put(url, {name: voIPPeerName}).toPromise();
  }

  private filterPeerConnections(pCons, params): any {
    return (params && params.mapFilter) ?
      PeerConnectionFilterService.mapFilter(pCons, params.searchObject) : pCons;
  }
}
